import {
  storeModules,
  storeUserPool,
  refreshSession,
  checkSession,
  redirect,
  renderApplication,
} from "./actionCreators"

export const mapState = (state) => ({
  userPool: state.sessionReducer.userPool,
  loggedIn: state.sessionReducer.loggedIn,
  detailsUrlPath: "/foundation_v1/sign-in-details",
  applicationClientId: state.sessionReducer.applicationClientId,
  userPoolId: state.sessionReducer.userPoolId,
})

export const mapDispatch = (dispatch) => ({
  redirect: (data) => redirect({ dispatch, ...data }),
  retrieveModulesSuccess: (user) => dispatch(storeModules(user)),
  storeUserPool: (data) => dispatch(storeUserPool(data)),
  checkSession: (...args) => checkSession(...args, dispatch),
  refreshSession: (data) => refreshSession({ ...data, dispatch }),
  renderApplication: () => dispatch(renderApplication()),
})
